import defaultBgRule from '../default';

const light = (params) => defaultBgRule.light(params);

export default light;
